import { render } from "./CaptureScreen.vue?vue&type=template&id=3cdf8546&scoped=true"
import script from "./CaptureScreen.vue?vue&type=script&lang=js"
export * from "./CaptureScreen.vue?vue&type=script&lang=js"

import "./CaptureScreen.vue?vue&type=style&index=0&id=3cdf8546&scoped=true&lang=css"

import exportComponent from "/Users/a2019/Documents/Project/MiniApp/miniapp_wing/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cdf8546"]])

export default __exports__